import React from 'react';

const TermsValueThree = () => {
  return (
    <div className="term-value-card">
      <div className="title">
        <h5>1,194 </h5>
        <h4>mmboe</h4>
        <p>Oil &amp; gas reserves &amp; resources</p>
      </div>
    </div>
  );
};

export default TermsValueThree;
